
<div :ref="uid" class="zone-escamotable" :class="jel_getClassObject(content)">
  <div :class="{ 'mb-2': content.niveauZone }" @click="toggleZoneEscamotable()">
    <div
      class="d-flex flex-row align-items-top justify-content-between"
      :class="[content.niveauZone, { 'nouveau-actif': isAfficherNouveaute }]"
    >
      <button
        :data-aide="isAide ? titre : ''"
        class="btnVide largeurZoneEscamotable px-0"
        :class="{ 'my-auto': content.niveauZone }"
      >
        <span v-if="isAfficherNouveaute" class="nouveau">
          {{ $tc('messageComponent.nouveau') }}
        </span>
        <Heading
          :id="reference"
          class="titre titre-zone-escamotable pt-0"
          :class="{ 'pb-0': content.niveauZone }"
          :contentType="content.typeTitre || 'titre'"
          v-html="titre"
        />
      </button>
      <svg-icon
        :data-aide="isAide ? titre : ''"
        icon-name="fleche-gauche"
        class="icon-fleche my-auto"
        :class="isOuvert ? 'rotation90' : 'rotation270'"
      />
    </div>
  </div>
  <div
    class="largeurZoneEscamotable marge-zone-escamotable"
    :class="{ graphik_regular: !imbrique }"
  >
    <b-collapse :visible="isOuvert">
      <div v-if="!imbrique" class="m-0 style-champ-riche mb-1" v-html="texte" />
      <div v-for="(questionRep, index) in questionsReponses" v-else :key="questionRep">
        <div class="d-flex flex-column">
          <ZoneEscamotable :content="getContentZoneEscamotable(questionRep)" />
          <Separateur
            v-if="index != content.typeZone.listeIdRubriqueAide.length - 1"
            class="w-100 mt-0"
          />
        </div>
      </div>
      <EditableArea
        v-if="content.contenuEditable"
        :content="content.contenuEditable"
        :parentTemplateId="metadata['mgnl:template']"
      />
    </b-collapse>
  </div>
</div>
